import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TodayIcon(props: IconProps) {
    return <Icon {...props} iconKey={"today"}/>
}
